import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12a4 4 0 1 1 8 0a4 4 0 0 1 -8 0","key":"svg-0"}],["path",{"d":"M12 12h8","key":"svg-1"}],["path",{"d":"M17 15l3 -3l-3 -3","key":"svg-2"}]]

/**
 * IconSwipeRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3dpcGUtcmlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTJhNCA0IDAgMSAxIDggMGE0IDQgMCAwIDEgLTggMCIgLz4KICA8cGF0aCBkPSJNMTIgMTJoOCIgLz4KICA8cGF0aCBkPSJNMTcgMTVsMyAtM2wtMyAtMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/swipe-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSwipeRight = createReactComponent('outline', 'swipe-right', 'SwipeRight', __iconNode);

export default IconSwipeRight;